module.exports = __webpack_public_path__ + "img/HR.8668bd72.png";